import { LoginTypes, confirmUserLogin } from '@api/login';
import Button from '@components/Button';
import OTPInput from '@components/Molecules/OTPInput';
import { getCompanyDetails, getTokenVerifiedUser } from '@helpers/auth.helper';
import { useAppDispatch } from '@hooks/useAppDispatch';
import useIsMobileApp from '@hooks/useIsMobileApp';
import { showToast } from '@shared/atoms';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getUserStatusData } from 'store/Actions/UserStatusAction';
import styles from './index.module.scss';

const TokenInput: React.FunctionComponent<TokenInputProps> = (props) => {
  const { email } = props;
  const location = useLocation();
  const otpLength = 6;
  const [otp, setOtp] = useState('');
  const [isError, setIsError] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const isMobileApp = useIsMobileApp();
  const dispatch = useAppDispatch();
  const redirectPath = localStorage.getItem('redirectPath');
  const isDirectLink = localStorage.getItem('isDirectLink') === 'true';
  const params = new URLSearchParams(location.search);
  const redirectedBy = params.get('redirectedBy');
  const rememberMe = localStorage.getItem('rememberMe');
  const validatedRememberMe = Boolean(rememberMe && rememberMe === 'true') || false;

  const resolvePostLoginHref = () => {
    if (redirectPath) {
      return redirectPath.charAt(0) === `/` ? redirectPath : `/${redirectPath}`;
    }

    return isMobileApp ? '/?isMobileApp=true' : '/';
  };

  useEffect(() => {
    if (otp.trim().length === otpLength) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [otp, otp.length]);

  const handleOnChange = (value: string) => {
    setOtp(value);
  };

  const handleConfirm = async () => {
    setIsDisabled(true);

    try {
      await getTokenVerifiedUser(
        otp,
        LoginTypes.TOKEN,
        isMobileApp,
        email,
        undefined,
        isDirectLink,
        redirectedBy,
        validatedRememberMe,
      );

      await getCompanyDetails();
      await confirmUserLogin({ type: LoginTypes.TOKEN });
      setIsError(false);
      dispatch(getUserStatusData());
      window.location.href = resolvePostLoginHref();

      setTimeout(() => {
        localStorage.removeItem('isDirectLink');
      }, 2000);
    } catch (err) {
      setIsError(true);
      setIsDisabled(false);
      const message =
        err instanceof Error && err.message
          ? err.message
          : 'Invalid verification code. Please try again.';
      showToast(message, undefined, 'error');
    }
  };

  return (
    <>
      <div className={styles.tokenContainer}>
        <OTPInput value={otp} valueLength={otpLength} onChange={handleOnChange} isError={isError} />
      </div>
      <Button type="primary" isButton isDisabled={isDisabled} onClick={handleConfirm} width="100%">
        Continue
      </Button>
    </>
  );
};

TokenInput.displayName = 'TokenInput';

interface TokenInputProps {
  email: string;
}

export default TokenInput;
